export function getVanWestendorpRecallAnswers(
  vanWestendorpQuestion,
  usePlaceholder = false,
) {
  const cheapAnswer = vanWestendorpQuestion?.answers?.[1];
  const expensiveAnswer = vanWestendorpQuestion?.answers?.[2];

  if (!cheapAnswer || !expensiveAnswer) {
    return { cheap: null, expensive: null };
  }

  const { label: questionLabel } = vanWestendorpQuestion;
  const cheapPrompt = `${cheapAnswer.label} - ${
    usePlaceholder ? cheapAnswer.placeholder : cheapAnswer.body
  }`;
  const expensivePrompt = `${expensiveAnswer.label} - ${
    usePlaceholder ? expensiveAnswer.placeholder : expensiveAnswer.body
  }`;

  return {
    cheap: {
      ...cheapAnswer,
      label: `${questionLabel}:`,
      prompt: cheapPrompt,
    },
    expensive: {
      ...expensiveAnswer,
      label: `${questionLabel}:`,
      prompt: expensivePrompt,
    },
  };
}
